module.exports = __webpack_public_path__ + "static/media/ios-journal.7f15ea78.svg";